import apiClient from '../../../utilities/apiClient';

export const cloneingData = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.actions}/${url}`, payload, true);
};
// allsearch
export const allsearch = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.actions}/${url}`, payload, true);
};
